import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    api("/auth/google", { method: "POST", body: JSON.stringify({ session_id: sessionId }) })
      .then(() => {
        setDone(true);
        toast.success("Signed in with Google. Welcome back!");
        navigate("/admin", { replace: true });
      })
      .catch((err) => {
        toast.error(err.message || "Google sign-in failed. Use email & password instead.");
        navigate("/admin", { replace: true });
      });
  }, [hash, navigate]);

  return (
    <div className="min-h-screen bg-ink text-white flex flex-col items-center justify-center gap-4">
      {done ? (
        <Loader2 className="h-8 w-8 animate-spin text-emerald-400" />
      ) : (
        <>
          <Loader2 className="h-8 w-8 animate-spin text-emerald-400" />
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-slate-400">
            Signing you in with Google
          </p>
        </>
      )}
    </div>
  );
}